import { NavLink } from "react-router-dom";
import { FaFire, FaHeart, FaClock, FaRegCommentDots } from "react-icons/fa";
import { useSelector } from "react-redux";

const navItemClass = ({ isActive }) =>
  `flex flex-col items-center transition ${isActive ? "text-red-500" : "text-white"
  }`;

export default function BottomNav() {

  const totalUnread = useSelector((state) => state.message.totalUnread);

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-black text-white border-t border-gray-800 p-2 flex justify-around items-center md:hidden z-50">

      <NavLink to="/explore" className={navItemClass}>
        <FaFire className="text-xl" />
        <span className="text-[11px]">Explore</span>
      </NavLink>

      <NavLink to="/followings" className={navItemClass}>
        <FaHeart className="text-xl" />
        <span className="text-[11px]">Followings</span>
      </NavLink>

      <NavLink to="/history" className={navItemClass}>
        <FaClock className="text-xl" />
        <span className="text-[11px]">History</span>
      </NavLink>

      <NavLink to="/messages" className={`${navItemClass} relative`}>
        <div className="relative flex flex-col items-center justify-center">
          <FaRegCommentDots className="text-xl" />

          {totalUnread > 0 && (
            <span className="absolute -top-2 right-1 min-w-[18px] h-[18px] px-1 rounded-full bg-red-500 text-white text-[11px] font-bold flex items-center justify-center leading-none">
              {totalUnread > 9 ? "9+" : "1"}
            </span>
          )}

          <span className="text-[11px]">Messages</span>
        </div>
      </NavLink>

    </nav>
  );
}